// Provides `articleJsonldScript` computed for the Article JSON-LD schema.
// Consuming component must expose `this.article` and `this.siteSettings`.
import { safeJsonLd, toIsoDate } from "@/utils/jsonldSafe";

export default {
  computed: {
    articleJsonldScript() {
      const a = this.article;
      if (!a) return null;

      const baseUrl = `https://${this.$config.website.domain}`;
      const url = `${baseUrl}${this.$route.path}`;
      const imageUrl =
        a.socialShareImage?.url ||
        a.heroImage?.url ||
        this.siteSettings?.defaultShareImage?.url;

      const author = a.author
        ? {
            "@type": "Person",
            name: a.author.name,
            ...(a.author.role ? { jobTitle: a.author.role } : {}),
            ...(a.author.linkedInUrl
              ? { url: a.author.linkedInUrl, sameAs: [a.author.linkedInUrl] }
              : {}),
          }
        : undefined;

      const logoUrl = this.siteSettings?.logo?.url;
      const publisher = {
        "@type": "Organization",
        name: "LeisureCraft",
        ...(logoUrl
          ? { logo: { "@type": "ImageObject", url: logoUrl } }
          : {}),
      };

      const schema = {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: a.title,
        description: a.seoDescription || a.deck,
        ...(imageUrl ? { image: [imageUrl] } : {}),
        ...(a.articlePublishedAt
          ? { datePublished: toIsoDate(a.articlePublishedAt) }
          : {}),
        ...(a.articleUpdatedAt
          ? { dateModified: toIsoDate(a.articleUpdatedAt) }
          : {}),
        ...(author ? { author } : {}),
        publisher,
        mainEntityOfPage: { "@type": "WebPage", "@id": url },
      };

      return {
        hid: "jsonld-article",
        type: "application/ld+json",
        innerHTML: safeJsonLd(schema),
      };
    },
  },
};
